<template>
<div>
    <v-card flat class="mx-auto">
        <!-- <div class="px-5 py-6 d-flex align-center justify-space-between primary">
            <div class="d-flex align-center">
                <v-icon color="white" small class="mr-3">fa-file</v-icon>
                <div class="white--text title font-weight-regular">My team challenges</div>
            </div>
        </div> -->

        

        <div v-if="loaded" style="border: 1px solid #CCCCCC">
            <div class="py-4 primary text-end" v-if="!user.role.student">
                <v-btn depressed class="accent mr-4" @click="showPF=true">
                    <v-icon small color="white" left>fa-cloud-upload-alt</v-icon>
                    Upload file
                </v-btn>
            </div>

            <template v-if="work.length > 0">
                <div v-if="creativity.length>0">
                    <div class="caption py-2 px-3 grey lighten-4 primary--text font-weight-medium">CREATIVITY CHALLENGE</div>
                    <div v-for="(it, index) in creativity" :key="it.id">
                        <ListTeamFiles :it="it" :fromTeam="true" @reinit="reinit" />
                        <div class="d-flex justify-center" v-if="index<creativity.length-1">
                            <v-divider></v-divider>
                        </div>
                    </div>
                </div>

                <div v-if="communication.length>0">
                    <div class="caption py-2 px-3 grey lighten-4 primary--text font-weight-medium">COMMUNICATION CHALLENGE</div>
                    <div v-for="(it, index) in communication" :key="it.id">
                        <ListTeamFiles :it="it" :fromTeam="true" @reinit="reinit" />
                        <div class="d-flex justify-center" v-if="index<communication.length-1">
                            <v-divider></v-divider>
                        </div>
                    </div>
                </div>

                <div v-if="entrepreneurship.length>0">
                    <div class="caption py-2 px-3 grey lighten-4 primary--text font-weight-medium">ENTREPRENEURSHIP CHALLENGE</div>
                    <div v-for="(it, index) in entrepreneurship" :key="it.id">
                        <ListTeamFiles :it="it" :fromTeam="true" @reinit="reinit" />
                        <div class="d-flex justify-center" v-if="index<entrepreneurship.length-1">
                            <v-divider></v-divider>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <div>
            <SendingLoader v-if="!loaded" />
        </div>

        <div class="caption text-center font-weight-medium grey--text text--darken-2 px-3 py-12" 
            v-if="creativity.length == 0 && communication.length == 0 && entrepreneurship.length == 0 && loaded">
            NO FILES UPLOADED YET.
        </div>
    </v-card>

    <DiagWorkTeam 
        :model="showPF"
        :team="team"
        @cancel="showPF=false"
        @close="reinit" />
</div>
</template>

<script>
import FormatDate from '@/services/formatDate'
import Work from '@/firebase/work'
import ListTeamFiles from '@/components/profile/ListTeamFiles'
import DiagWorkTeam from '@/components/core/dialogs/DiagWorkTeam'

export default {
    data: () => ({
        loaded: false,
        work: [],
        creativity: [],
        communication: [],
        entrepreneurship: [],
        showPF: false
    }),
    props: ['team'],
    components: {
        ListTeamFiles,
        DiagWorkTeam
    },
    mounted() {
        this.init();
    },
    methods: {
        reinit() {
            this.work = [];
            this.creativity = [];
            this.communication = [];
            this.entrepreneurship = [];
            this.showPF = false;
            this.init();
        },
        init() {
            Work.getAllFromTeam(this.team)
                    .then(response => {
                        if (response.status === true) {
                            response.query.forEach(dt => {
                                let tempo = dt.data();
                                tempo.id = dt.id;
                                tempo.formattedDate = FormatDate.getFormatted(tempo.date);
                                tempo.comments = [];
                                this.work.push(tempo);
                            }),
                            this.work = _.orderBy(this.work, 'date', 'desc');
                            this.work.forEach(dt => {
                                if (dt.category == 'creativity') this.creativity.push(dt);
                                if (dt.category  == 'communication') this.communication.push(dt);
                                if (dt.category  == 'entrepreneurship') this.entrepreneurship.push(dt);
                            });
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>